<template>
  <div>
    <Form ref="topicForm" :rules="ruleValidate" :model="topicInfo" :label-width="120">
      <div class="title">基本信息</div>
      <FormItem label="所属考点" prop="points">
        <!-- <Cascader :data="points" v-model="topicInfo.points" clearable></Cascader> -->
        <cascader-multi style="width:300px;" :data="points" v-model="topicInfo.points"></cascader-multi>
      </FormItem>
      <FormItem label="试题类型" prop="type">
        <EnumSelect
          type="QuestionType"
          selector="select"
          v-model="topicInfo.type"
          @onChange="changeType"
          :except="['4']"
          style="width:200px"
        ></EnumSelect>
      </FormItem>
      <FormItem :label="topicInfo.type==4?'连线题大题干':'题干'" prop="title">
        <UEditor v-model="topicInfo.title" :maxlength="300" :height="150"></UEditor>
      </FormItem>
      <div v-if="topicInfo.type==4">
        <FormItem
          class="stem"
          v-for="(stem,index) in topicInfo.stems"
          :label="'题干'+(index+1)"
          :prop="'stem'+index"
          :key="index"
        >
          <UEditor v-model="stem.title" :maxlength="300" :height="150"></UEditor>
          <div class="right">
            <div>
              <i
                class="ivu-icon ivu-icon-ios-trash-outline"
                @click="deleteStem(index)"
                style="font-size: 32px;"
              ></i>
            </div>
            <div>正确答案</div>
            <RadioGroup v-model="stem.right" :vertical="true">
              <Radio
                v-for="(option,index) in topicInfo.options"
                :label="index"
                :key="index"
              >选项{{chars[index]}}</Radio>
            </RadioGroup>
          </div>
        </FormItem>
        <FormItem class="center">
          <Button type="default" @click="addStem" :disabled="topicInfo.stems.length==6">
            <i class="ivu-icon ivu-icon-ios-add"></i>
            <span>新增题干（{{topicInfo.stems.length}}/6）</span>
          </Button>
        </FormItem>
      </div>
      <FormItem v-if="topicInfo.type!= 5 " label="选项" prop="options">
        <div class="option" v-for="(option,index) in topicInfo.options" :key="index">
          <span>选项{{chars[index]}}</span>
          <UEditor v-model="option.title" :maxlength="300" :height="150"></UEditor>
          <Radio
            v-model="option.is_right"
            v-if="topicInfo.type==1||topicInfo.type==3"
            @on-change="setRightOption(index)"
          >正确</Radio>
          <Checkbox v-else-if="topicInfo.type==2" v-model="option.is_right">正确</Checkbox>
          <i
            v-if="topicInfo.type!=3"
            class="ivu-icon ivu-icon-ios-trash-outline"
            @click="deleteOption(index)"
            style="font-size: 32px;"
          ></i>
        </div>
        <div class="center" v-if="topicInfo.type!=3">
          <Button type="default" @click="addOption" :disabled="topicInfo.options.length==6">
            <i class="ivu-icon ivu-icon-ios-add"></i>
            <span>新增选项（{{topicInfo.options.length}}/6）</span>
          </Button>
        </div>
      </FormItem>
      <!-- <FormItem v-else label="答案" prop="answer">
        <UEditor v-model="topicInfo.answer" :maxlength="300" :height="150"></UEditor>
      </FormItem> -->
      <FormItem label="试题解析" prop="analysis">
        <UEditor v-model="topicInfo.analysis" :maxlength="300" :height="150"></UEditor>
      </FormItem>
      <FormItem class="center">
        <Button size="large" @click="goBack">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('topicForm')"
          :loading="loading"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import UEditor from "@/components/UEditor.vue";
import CascaderMulti from "@/components/CascaderMulti";

let chars = { 0: "A", 1: "B", 2: "C", 3: "D", 4: "E", 5: "F" };

export default {
  name: "QuestionBankTopicEdit",
  mounted(){
    this.mathJax()
  },
  components: {
    UEditor,
    CascaderMulti
  },
  data() {
    return {
      showSelectPoint: false,
      pointName: "",
      points: [],
      selectedPoints: [],
      pointColumns: [
        {
          title: "考点名称",
          key: "name"
        },
        {
          title: "操作",
          slot: "action",
          key: "address",
          width: 140
        }
      ],
      chars: chars,
      topicInfo: {
        points: [],
        type: "1",
        title: "",
        options: [],
        stems: [],
        analysis: "",
        answer: "",
        bank: ""
      },
      ruleValidate: {
        type: [
          {
            required: true,
            message: "试题类型不能为空"
          }
        ],
        title: [
          {
            required: true,
            message: "题干不能为空",
            trigger: "change"
          }
        ],
        options: []
      },
      loading: false
    };
  },
  async created() {
    let that = this;
    this.ruleValidate.options = [
      {
        required: true,
        type: "array",
        min: 1,
        trigger: "change",
        validator: (rule, value, callback) => {
          if (value.length == 0) {
            callback(new Error("选项不能为空"));
          } else {
            if (
              that.topicInfo.type == 2 &&
              value.filter(o => o.is_right == 1).length <= 1
            ) {
              callback(new Error("多选题正确答案至少为两个"));
            } else if (
              that.topicInfo.type != 4 &&
              value.filter(o => o.is_right == 1).length == 0
            ) {
              callback(new Error("正确答案不能为空"));
            } else {
              let i = 0;
              for (; i < value.length; i++) {
                if (value[i].title == "") {
                  callback(new Error("选项" + chars[i] + "不能为空"));
                  break;
                }
              }
              if (i == value.length) {
                callback();
              }
            }
          }
        }
      }
    ];
    let func = index => {
      return [
        {
          required: true,
          validator: (rule, value, callback) => {
            let stem = that.topicInfo.stems[index];
            if (stem.title === "") {
              callback(new Error("题干内容不能为空"));
            } else if (stem.right === "") {
              callback(new Error("题干正确答案不能为空"));
            } else {
              callback();
            }
          }
        }
      ];
    };
    for (let i = 0; i < 6; i++) {
      this.$set(this.ruleValidate, "stem" + i, func(i));
    }

    await this.getPoint();
    await this.getData();
  },
  methods: {
    mathJax() {
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
      },2000)
    },
    async getData() {
      let id = this.$route.query.id;
      if (!id) {
        this.topicInfo.bank = this.$route.query.bank;
        return;
      }
      let data = await this.$http.get("/api/question/" + id);
      this.topicInfo.bank = data.bank_id;
      this.topicInfo.title = data.ques_stem;
      this.topicInfo.type = data.ques_type.toString();
      if (data.point && data.point.length > 0) {
        // let pointId = data.point[data.point.length - 1].id;
        // let points = [];
        // let getPoint = function(list) {
        //   for (let i = 0; i < list.length; i++) {
        //     let p = list[i];
        //     if (p.value == pointId) {
        //       points.push(p.value);
        //       return p.value;
        //     } else {
        //       if (!p.children || p.children.length == 0) {
        //         return;
        //       } else {
        //         let id = getPoint(p.children);
        //         if (id) {
        //           points.unshift(p.value);
        //           return p.value;
        //         }
        //       }
        //     }
        //   }
        // };
        // getPoint(this.points);
        const points = [];
        data.point.forEach(i => {
          points.push(i.id);
        })
        this.topicInfo.points = points;
      }
      this.topicInfo.analysis = data.ques_analysis;
      if ( data.ques_type == 5 ) {
        this.topicInfo.answer = data.right_answer;
      }
      if (data.ques_type != 4) {
        data.ques_option.forEach(o => {
          this.topicInfo.options.push({
            title: o.content,
            is_right: o.is_right == 1
          });
        });
      } else {
        data.ques_option.left.forEach(o => {
          this.topicInfo.stems.push({
            title: o.content,
            right: o.is_right - 1
          });
        });
        data.ques_option.right.forEach(o => {
          this.topicInfo.options.push({
            title: o.content
          });
        });
      }
    },
    async getPoint() {
      let list = await this.$http.get("/api/exam/point");
      let points = [];
      let pointFormat = function(point) {
        let newPoint = { value: point.id, label: point.name, children: [] };
        if (point.child) {
          point.child.forEach(p => {
            newPoint.children.push(pointFormat(p));
          });
        }
        return newPoint;
      };
      list.forEach(p => {
        if (!p.child || p.child.length == 0) {
          return;
        }
        let point = pointFormat(p);
        points.push(point);
      });
      this.points = points;
    },
    async deleteOption(index) {
      await this.$promiseConfirm("确定要删除该选项吗？");
      this.topicInfo.options.splice(index, 1);
      if (this.topicInfo.type == 4) {
        this.topicInfo.stems.forEach(s => {
          if (s.right >= index) {
            s.right = "";
          }
        });
      }
    },
    addOption() {
      this.topicInfo.options.push({ title: "", is_right: false });
      this.$refs.topicForm.validateField("options");
    },
    setRightOption(index) {
      for (let i = 0; i < this.topicInfo.options.length; i++) {
        if (i != index) {
          this.topicInfo.options[i].is_right = false;
        }
      }
    },
    async changeType() {
      this.topicInfo.stems = [];
      if (this.topicInfo.type == 3) {
        this.topicInfo.options = [
          { title: "", is_right: false },
          { title: "", is_right: false }
        ];
      } else {
        this.topicInfo.options = [];
      }
    },
    addStem() {
      this.topicInfo.stems.push({ title: "", right: "" });
    },
    async deleteStem(index) {
      await this.$promiseConfirm("确定要删除该题干吗？");
      this.topicInfo.stems.splice(index, 1);
    },
    async submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        if (this.topicInfo.type == 2 && this.topicInfo.options.length <= 1) {
          await this.$promiseAlert("多选题至少两个选项", { type: "warning" });
          return;
        } else if (this.topicInfo.type == 4) {
          if (this.topicInfo.stems.length <= 1) {
            await this.$promiseAlert("连线题至少两个题干", { type: "warning" });
            return;
          } else if (this.topicInfo.options.length <= 1) {
            await this.$promiseAlert("连线题至少两个选项", { type: "warning" });
            return;
          }
        }
        // let data = {
        //   point:
        //     this.topicInfo.points.length > 0
        //       ? this.topicInfo.points[this.topicInfo.points.length - 1]
        //       : "",
        //   ques_type: this.topicInfo.type,
        //   ques_stem: this.topicInfo.title,
        //   ques_analysis: this.topicInfo.analysis,
        //   bank_id: this.topicInfo.bank
        // };
        let data = {
          point: this.topicInfo.points.join(),
          ques_type: this.topicInfo.type,
          ques_stem: this.topicInfo.title,
          ques_analysis: this.topicInfo.analysis,
          bank_id: this.topicInfo.bank
        };
        if ( data.ques_type == 5  ) {
          data.answer = this.topicInfo.answer;
        }
        if (data.ques_type != 4) {
          let options = [];
          this.topicInfo.options.forEach(o => {
            options.push({ content: o.title, is_right: o.is_right ? 1 : 0 });
          });
          data.ques_option = JSON.stringify(options);
        } else {
          let options = [];
          this.topicInfo.stems.forEach(o => {
            options.push({ content: o.title, is_right: o.right + 1 });
          });
          data.ques_option = JSON.stringify(options);
          let results = [];
          this.topicInfo.options.forEach(o => {
            results.push({ content: o.title });
          });
          data.connection_result = JSON.stringify(results);
        }
        let id = this.$route.query.id;
        try {
          this.loading = true;
          if (id) {
            await this.$http.put("/api/question/" + id, data);
            this.$Message.saveSuccess();
          } else {
            await this.$http.post("/api/question", data);
            this.$Message.createSuccess();
          }
        } finally {
          this.loading = false;
        }
        this.$router.go(-1);
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-btn-text {
  color: #2d8cf0 !important;
  padding-left: 0;
  padding-right: 0;
  border: none;
  background: none;
}
.option {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  span {
    white-space: nowrap;
  }
  /deep/ .ueditor {
    margin: 0 10px;
  }
  /deep/ .ivu-checkbox-wrapper {
    white-space: nowrap;
  }
}
.center {
  padding-top: 10px;
}
.ivu-icon-ios-trash-outline {
  cursor: pointer;
}
.stem {
  /deep/ .ivu-form-item-content {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .right {
    white-space: nowrap;
    text-align: center;
    margin-left: 10px;
  }
}
</style>
